import React, { useState } from "react";
import { useLocale } from "../../../contexts/localeContext";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { Field, useFormikContext } from "formik";
import { getArrayBufferFromBlob } from "../../../exporters/LicenseHelper";
import { requiredValidation } from "../../../utilities/Validation";
import Label from "../../label/label";

const ImportCrlContent = () => {
    const { translate } = useLocale();
    const { setFieldValue } = useFormikContext<any>();
    const [caVisible, setCaVisible] = useState(false);

    const readFile = async (file) => {
        const arrayBuffer = await getArrayBufferFromBlob(file);
        const fileAsByteArray = Object.values(arrayBuffer);
        return fileAsByteArray;
    }

    /**
     * Allow the user to select the PEM Certificate Authority (CA).
     * @param event
     */
    const onBrowsePemCaCert = async (event) => {
        const file = event.target.files[0];
        if (!file) {
            return;
        }

        const fileContentBytes = await readFile(file);
        setFieldValue("pemCaCertificate", file.name);
        setFieldValue("caCertificateFileContent", fileContentBytes);
    };

    /**
     * Allow the user to select the PEM Certificate.
     * @param event
     */
    const onBrowsePemCrlCertificate = async (event) => {
        const file = event.target.files[0];
        if (!file) {
            return;
        }

        const fileContentBytes = await readFile(file);
        setFieldValue("pemCrlCertificate", file.name);
        setFieldValue("pemCrlCertificateFileContent", fileContentBytes);
    };

    const onCaLinkedChange = async (check: boolean) => {
        setFieldValue("caLinkedChange", check);
        setCaVisible(check);
    }

    return <>
        <div className="flex flex-col  p-5 w-full">
            <div className="flex items-center mb-4">
                <Field
                    type="checkbox"
                    name={"showCaCertificate"}
                    id={"showCaCertificate"}
                    checked={caVisible}
                    onChange={e => onCaLinkedChange(e.target.checked)} />
                <Label htmlFor="showCaCertificate" className="ml-1 text-sm text-gray-700">{translate.byKey(TranslationKeys.linkCaCertificate)}</Label>
            </div>
            {/* PEM CRL Certificate */}
            <div className="flex flex-row mt-2 ">
                <div className="flex flex-col w-full">
                    <Label htmlFor='pemCrlCertificate' required className="text-xs text-gray-600">{translate.byKey(TranslationKeys.pemCrl)}:</Label>
                    <Field
                        disabled={true} // User needs to select the certificate instead of typing it in.
                        name="pemCrlCertificate"
                        type="text"
                        validate={requiredValidation}
                        className="flex flex-row items-center p-1 text-gray-800 text-sm bg-gray-input" />
                </div>
                <div className="flex flex-col flex-1 w-20 mt-5">
                    <div className='flex flex-row ml-2 px-4 p-1 rounded-lg shadow text-white text-xs  bg-sidemenu-focus cursor-pointer'>
                        <Label htmlFor="pemCrlCertificate" className="items-center">{translate.byKey(TranslationKeys.browse)}</Label>
                        <Field
                            name="pemCrlCertificateFile"
                            as="input"
                            type="file"
                            accept=".pem"
                            data-testid="btn_pemCrlCertificate"
                            id="pemCrlCertificate"
                            className="hidden"
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onBrowsePemCrlCertificate(e)} />
                    </div>
                </div>
            </div>
            {/* PEM CA Certificate */}
            {caVisible &&
                <div className="flex flex-row mt-2 ">
                    <div className="flex flex-col w-full">
                        <Label htmlFor='pemCaCertificate' required className="text-xs text-gray-600">{translate.byKey(TranslationKeys.pemCaCertificate)}:</Label>
                        <Field
                            disabled={true} // User needs to select the certificate instead of typing it in.
                            name="pemCaCertificate"
                            type="text"
                            visable={caVisible}
                            validate={requiredValidation}
                            className="flex flex-row items-center p-1 text-gray-800 text-sm bg-gray-input" />
                    </div>
                    <div className="flex flex-col flex-1 w-20 mt-5">
                        <div className='flex flex-row ml-2 px-4 p-1 rounded-lg shadow text-white text-xs  bg-sidemenu-focus cursor-pointer'>
                            <Label htmlFor="pemCaCertificate" className="items-center"> {translate.byKey(TranslationKeys.browse)}</Label>
                            <Field
                                name="pemCaCertificateFile"
                                as="input"
                                type='file'
                                accept='.pem'
                                data-testid="btn_pemCaCertificate"
                                id='pemCaCertificate'
                                className='hidden'
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => onBrowsePemCaCert(e)} />
                        </div>
                    </div>
                </div>
            }
            <div className="flex justify-end mt-6">
                <button
                    type="submit"
                    className="h-8 px-2 secondary secondary-enabled bg-sidemenu-focus text-white shadow-lg">
                    {translate.byKey(TranslationKeys.importCrl)}
                </button>
            </div>
        </div>
    </>
};

export default ImportCrlContent;